import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, RouteComponentProps, Redirect } from 'react-router-dom';
import { IEventChannel } from '../../../events/EventChannel';
import { TOPICS } from '../../../events/constants';
import { Store } from '../../../types/store';
import { FaqSectionPage } from './components/SectionPage/SectionPage';
import { FaqQuestionPage } from './components/QuestionPage/QuestionPage';
import { FaqSection } from '../../../api/types/faq-content-api';
import { getFaqSections } from '../../../api/faq-content-service-api';

interface IFaqAppProps {
    eventChannel: IEventChannel;
}

const FaqApp = (props: IFaqAppProps) => {
    const attachNearestStoreChangeEventHandlers = () => {
        const handleEvent = (store: Store) => {
            if (store && store.Id && store.Id !== nearestStoreId) {
                setNearestStoreId(store.Id);
            }
        };
        props.eventChannel.subscribe(TOPICS.MY_STORE_MODULE_UPDATES, handleEvent);
    };
    attachNearestStoreChangeEventHandlers();

    const updateCanonicalLink = () => {
        const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
        if (canonical && !canonical.href.match(window.location.pathname)) {
            canonical.href = `https://www.carmax.com${window.location.pathname}`;
        }
    };

    const [nearestStoreId, setNearestStoreId] = useState<string>();
    const [faqData, setFaqData] = useState<FaqSection[]>();

    const getAllSections = () => {
        getFaqSections().then(setFaqData);
    };

    useEffect(() => {
        if (!faqData) {
            getAllSections();
        }
    }, [faqData]);

    const renderFAQSectionPage = (routeProps: RouteComponentProps) => {
        updateCanonicalLink();
        return <FaqSectionPage {...routeProps} allSections={faqData} />;
    };

    const renderFAQQuestionPage = (routeProps: RouteComponentProps) => {
        updateCanonicalLink();
        return <FaqQuestionPage {...routeProps} allSections={faqData} nearestStoreId={nearestStoreId} />;
    };

    return (
        // @ts-expect-error - Children do exist, but types are not properly inferred
        <Router basename={'/faq'}>
            <Switch>
                <Route
                    path="/home-delivery"
                    render={() => {
                        return <Redirect to="/buying-a-car" />;
                    }}
                />
                <Route
                    path="/carmax-curbside"
                    render={() => {
                        return <Redirect to="/buying-a-car" />;
                    }}
                />
                {/* The following routes with ids need to be rerouted to question pages until those .com links are replaced */}
                <Route
                    path="/buying-a-car#30days"
                    render={() => {
                        return <Redirect to="/buying-a-car/do-i-really-get-30-days-to-return-the-car" />;
                    }}
                />
                <Route
                    path="/seeing-a-car#24hrtest"
                    render={() => {
                        return <Redirect to="/seeing-a-car/how-do-i-get-a-24-hour-test-drive-at-carmax" />;
                    }}
                />
                <Route
                    path="/warranties#ltdwarranty"
                    render={() => {
                        return (
                            <Redirect to="/warranties/do-all-of-carmax-cars-come-with-the-carmax-limited-warranty" />
                        );
                    }}
                />
                <Route
                    path="/warranties#lycg"
                    render={() => {
                        return <Redirect to="/warranties/what-is-carmax-love-your-car-guarantee" />;
                    }}
                />
                <Route path="/:section/:section" render={renderFAQQuestionPage} />
                <Route path="/:section" render={renderFAQSectionPage} />
            </Switch>
        </Router>
    );
};

export default FaqApp;
